<template>
	<div
		v-if="isOnline === false"
		class="connection-status"
		:class="{ '--offline': !isOnline }"
		role="status"
		aria-live="polite"
	>
		<Icon
			name="material-symbols:android-wifi-3-bar-alert"
			size="16px"
		/>
		{{ isOnline ? 'Подключение активно' : 'Оффлайн-режим' }}
	</div>
</template>

<script setup lang="ts">
	import { useConnectionStatus } from '~/composables/useConnectionStatus';

	const isOnline = useConnectionStatus();
</script>

<style scoped lang="scss">
	.connection-status {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 7px;
		padding: 7px 12px;
		color: var(--white);
		font-size: 10px;
		font-weight: 400;
		background-color: #fdb528;
		width: 100%;
		height: 20px;
		border-radius: 12px;
		max-width: 800px;

		&__dot {
			width: 7px;
			height: 7px;
			border-radius: 50%;
			background: currentColor;
		}

		&.--offline {
		}
	}
</style>
